import React from 'react'
import { PieChart, Pie, Sector, Cell } from 'recharts'

const renderActiveShape = (props: any) => {
  const RADIAN = Math.PI / 180
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
    percent,
    value,
  } = props

  // Don't render the label if the value is 0
  if (value === 0) {
    return null
  }
  // For other cases (multiple slices)
  let sin = Math.sin(-RADIAN * midAngle)
  let cos = Math.cos(-RADIAN * midAngle)
  if (percent === 1) {
    sin = Math.sin(-90 * RADIAN)
    cos = Math.cos(-90 * RADIAN)
  }

  if (percent === 0.5) {
    const isLeftHalf = midAngle > 90 && midAngle < 270;
    sin = Math.sin(isLeftHalf ? (-135 * RADIAN) : (45 * RADIAN));
    cos = Math.cos(isLeftHalf ? (-135 * RADIAN) : (-45 * RADIAN));
  }

  const sx = cx + (outerRadius + 2) * cos
  const sy = cy + (outerRadius + 2) * sin
  const mx = cx + (outerRadius + 6) * cos
  const my = cy + (outerRadius + 6) * sin
  const ex = mx + (cos >= 0 ? 1 : -1) * 5
  const ey = my
  const textAnchor = cos >= 0 ? 'start' : 'end'

  // Special handling when there's only one slice (100%)
  if (percent === 1) {
    const x = cx + (outerRadius + 30) * Math.cos(-90 * RADIAN) // Position diagonally
    const y = cy + (outerRadius + 30) * Math.sin(-90 * RADIAN)
    return (
      <g>
        <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill='none' />
        <text x={x} y={y} fill='#333' textAnchor='middle' dominantBaseline='central' fontSize={8}>
          {payload.name}
        </text>
        <text
          x={x}
          y={y + 15}
          fill='#999'
          textAnchor='middle'
          dominantBaseline='central'
          fontSize={8}
        >
          {`${(percent * 100).toFixed(2)}%`}
        </text>
      </g>
    )
  }

  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill='none' />
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        textAnchor={textAnchor}
        fill='#777'
        // fill={mode === 'dark' ? '#fff' : '#333'}
        fontSize={8}
      >
        {payload.name}
      </text>
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey - 5}
        dy={18}
        textAnchor={textAnchor}
        fill='#999'
        fontSize={8}
      >
        {`${(percent * 100).toFixed(2)}%`}
      </text>
    </g>
  )
}

export const PieChartWidget = ({
  data,
  colors,
  height=200,
  width=215
}: {
  data: { name: string; value: number }[]
  colors: string[]
  height?: number
  width?: number
}) => {
  console.log(data, 'data')

  return (
    <div className='d-flex justify-content-center'>
      <PieChart width={width} height={height}>
        <Pie
          data={data}
          cx={100}
          cy={100}
          innerRadius={25}
          outerRadius={45}
          fill='#8884d8'
          dataKey='value'
          paddingAngle={0}
          startAngle={90} // Start the pie chart from the top
          endAngle={450}
          labelLine={false}
          label={renderActiveShape}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
          ))}
        </Pie>
      </PieChart>
    </div>
  )
}


